module.exports = __webpack_public_path__ + "configuration/config_prs.json";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=configuration/config_prs.json!./src/config/config_prs.json
// module id = 542
// module chunks = 3